import { render, staticRenderFns } from "./nav-main.vue?vue&type=template&id=c2b8bcb0"
import script from "./nav-main.vue?vue&type=script&lang=js"
export * from "./nav-main.vue?vue&type=script&lang=js"
import style0 from "./nav-main.vue?vue&type=style&index=0&id=c2b8bcb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports